import React from 'react';
import ReactDOM from 'react-dom/client';
import "../src/globals.css";
import { App } from './App';
// import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
    <Toaster position="top-center" reverseOrder={false} />
    {/* <ToastContainer position="top-right" autoClose={3000} /> */}
  </>
);
